"use client"

import AppImage from "./AppImage"

interface LoaderProps {
  message?: string
  fullScreen?: boolean
}

export function Loader({
  message = "Loading...",
  fullScreen = true,
}: LoaderProps) {
  return (
    <div
      className={
        fullScreen
          ? "flex min-h-screen w-full items-center justify-center bg-background"
          : "flex w-full items-center justify-center py-8"
      }
      role="status"
      aria-live="polite"
      aria-busy="true"
    >
      <div className="flex flex-col items-center gap-4">
        <AppImage
          src="/logos/MEVOLY_white1.png"
          alt="Mevoly Hair logo"
          width={176}
          height={44}
          priority
          className="h-auto w-44 object-contain"
        />
        <div className="h-6 w-6 animate-spin rounded-full border-2 border-primary/30 border-t-primary" />
        <p className="text-sm text-muted-foreground">{message}</p>
      </div>
    </div>
  )
}

